module.exports = __webpack_public_path__ + "img/bg-service-2.78125073.svg";